import type { ButtonFieldProps } from '@wk/components-react16';
import type { MouseEventHandler } from 'react';
import { create } from 'zustand';

type ToastType = 'success' | 'error' | 'info' | 'warning';
interface ToastAction extends ButtonFieldProps {
  label: string;
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
}
interface ToastStore {
  toasts: {
    id: string;
    title?: string;
    message?: string;
    type: ToastType;
    autoCloseTimeout?: number;
    actions?: ToastAction[];
  }[];
}

interface ToastFunctions {
  showToast: (
    type: ToastType,
    options: {
      title?: string;
      message?: string;
      actions?: ToastAction[];
      autoCloseTimeout?: number;
    },
  ) => void;
  removeToast: (id: string) => void;
}

const useToast = create<ToastStore & ToastFunctions>()((set) => ({
  toasts: [],
  showToast: (
    type: ToastType,
    options: { title?: string; message?: string; actions?: ToastAction[] },
  ) => {
    set((state) => ({
      toasts: [
        ...state.toasts,
        {
          id: Date.now().toString(),
          type,
          actions: options.actions,
          ...options,
        },
      ],
    }));
  },
  removeToast: (id: string) => {
    set((state) => ({
      toasts: state.toasts.filter((toast) => toast.id !== id),
    }));
  },
}));

export default useToast;
